import routerOptions0 from "/Users/wouter/prjs/wouter/krewebacchus/node_modules/.pnpm/nuxt@3.18.1_@parcel+watcher@2.5.1_@types+node@22.13.5_@vue+compiler-sfc@3.5.20_better-s_11a39451a577bef20859fcbcc9907341/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}